
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streams",
      function () {
        return require("private-next-pages/streams/index.tsx");
      }
    ]);
  